export const addressVerificationSteps = {
   AVAILABILITY_AT_ADDRESS: "avalilabelAtAdress",
   NON_AVAILABILITY_AT_ADDRESS: "notAvalilabelAtAdress",
   VERIFICATION_DENIAL: "denialOfVerification",
};

export const availableAtAdressForVerificationOptions = {
   AVAILABLE: "option_available",
   NOT_AVAILABLE: "option_not_available",
   DISCARD_VERIFICATION: "option_discard_verification",
};

export const nonAvailabilityAtAdressForVerificationOptions = {
   DOCUMENT_NEEDED: "option_document_needed",
   NOBODY_RESIDES: "option_nobody_resides",
   SHIFTED: "option_shifted",
};

export const advDenialOptions = {
   NOT_AWARE: "option_not_aware",
   NOT_DECIDED: "option_not_decided",
   LEFT_JOB: "option_left_job",
};